import { render, staticRenderFns } from "./addExcellence.vue?vue&type=template&id=33e921a8&scoped=true"
import script from "./addExcellence.vue?vue&type=script&lang=js"
export * from "./addExcellence.vue?vue&type=script&lang=js"
import style0 from "./addExcellence.vue?vue&type=style&index=0&id=33e921a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e921a8",
  null
  
)

export default component.exports